import React, { useCallback } from 'react';
import { Tag } from '../tag/index.js';
import 'tslib';
import 'classnames';
import '../../../../tag/esm/desktop';

var styles = {"dots":"pagination__dots_1g040"};
require('./index.css');

/* eslint-disable react/no-array-index-key */
var DefaultView = function (_a) {
    var _b = _a.sidePadding, sidePadding = _b === void 0 ? 2 : _b, _c = _a.activePadding, activePadding = _c === void 0 ? 1 : _c, pagesCount = _a.pagesCount, currentPageIndex = _a.currentPageIndex, _d = _a.onPageChange, onPageChange = _d === void 0 ? function () { return null; } : _d;
    var maxHalfCount = sidePadding + activePadding + 1;
    var maxElementsCount = maxHalfCount * 2 + 1;
    var itemsFit = pagesCount <= maxElementsCount;
    var elementsCount = itemsFit ? pagesCount : maxElementsCount;
    var getPageIndex = useCallback(function (elementIndex) {
        var lastIndex = pagesCount - 1;
        var reverseIndex = lastIndex - currentPageIndex;
        var lastElementIndex = elementsCount - 1;
        var reverseElementIndex = lastElementIndex - elementIndex;
        var hasCollapsedItems = function (index) { return !itemsFit && index >= maxHalfCount; };
        if (elementIndex < sidePadding) {
            return elementIndex;
        }
        if (elementIndex === sidePadding && hasCollapsedItems(currentPageIndex)) {
            return null;
        }
        if (reverseElementIndex === sidePadding && hasCollapsedItems(reverseIndex)) {
            return null;
        }
        if (reverseElementIndex < sidePadding) {
            return lastIndex - reverseElementIndex;
        }
        var computedIndex = currentPageIndex - maxHalfCount + elementIndex;
        return Math.min(lastIndex - reverseElementIndex, Math.max(elementIndex, computedIndex));
    }, [currentPageIndex, elementsCount, itemsFit, maxHalfCount, pagesCount, sidePadding]);
    return (React.createElement(React.Fragment, null, Array(elementsCount)
        .fill('')
        .map(function (_, i) {
        var pageIndex = getPageIndex(i);
        if (pageIndex === null) {
            return (React.createElement("div", { key: i.toString(), className: styles.dots }, "..."));
        }
        var active = currentPageIndex === pageIndex;
        return (React.createElement(Tag, { key: i.toString(), checked: active, disabled: active, onClick: function () { return onPageChange(pageIndex); } }, pageIndex + 1));
    })));
};

export { DefaultView };
